/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  formatCurrency,
  formatDate,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';

function LedgerTable({ fromDate, toDate, ledgerRows, onSort }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  return (
    <section className="p-3 table-label">
      <div className="app-container overflow-auto">
        {formattedMessage('from')}{' '}
        <span className="value">
          {formatDate(getNewDate(fromDate), DATE_MONTH_YEAR_VIEW_FORMAT)}
        </span>{' '}
        {formattedMessage('to')}{' '}
        <span className="value">
          {formatDate(getNewDate(toDate), DATE_MONTH_YEAR_VIEW_FORMAT)}
        </span>
        <table className="ledger-table w-100 mt-3 table-bordered">
          <thead>
            <tr>
              <td onClick={onSort} className="cursor-pointer">
                {formattedMessage('date')}
              </td>
              <td>Deposit Date</td>
              <td>{formattedMessage('type')}</td>
              <td>{formattedMessage('reference')}</td>
              <td>{formattedMessage('debit')}</td>
              <td>{formattedMessage('credit')}</td>
              <td>{formattedMessage('balance')}</td>
            </tr>
          </thead>
          <tbody>
            {ledgerRows.map((row) => (
              <React.Fragment key={row.TxReference}>
                <tr>
                  <td>{row.TxDate}</td>
                  <td>{row.TravelDate}</td>
                  <td>{row.TxType}</td>
                  <td>
                    <div>{row.TxReference}</div>
                  </td>
                  <td className="value">
                    {formatCurrency(Math.abs(row.Debit).toFixed(2))}
                  </td>
                  <td className="value">
                    {formatCurrency(row.Credit.toFixed(2))}
                  </td>
                  <td>{formatCurrency(row.Balance.toFixed(2))}</td>
                </tr>
                <tr>
                  <td colSpan={7}>
                    <div className="fs-14 secondary-text">{row.Narration}</div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

LedgerTable.propTypes = {
  ledgerRows: PropTypes.array.isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
};

export default LedgerTable;
